<template>
  <transition name="fade">
    <router-view></router-view>
  </transition>
</template>

<script>
  export default {
  }
</script>
<style lang="scss">
  *{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  html,body{
    width: 100%;
    height: 100%;
    font-size: 90%;
      font-family: 微软雅黑,Microsoft YaHei,Arial,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,sans-serif;
  }
</style>